import { useDialog } from '@/ui-plus/dialog/use-dialog';
import PhoneValidationForm from '@iframe-widgets/pages/widgets/dialogs/phone-validation/PhoneValidationForm.vue';
import { toast } from '@/ui-plus/sonner';

const dialog = useDialog();

// show phone validation form directly as iframe widgets are not used in partner-spa-vue
export function showPhoneValidationForm() {
    return new Promise((resolve) => {
        dialog.show({
            title: 'One-time phone verification',
            closeable: false,
            description: 'Please enter your mobile phone number for verification. This is a one-time process and will not be required in the future.',
            component: PhoneValidationForm,
            onSuccess: () => {
                resolve(1);
            },
            onError: (message: string) => {
                console.error(message);
                toast.error(message);
                resolve(-1);
            },
            onCancel: () => {
                resolve(-1);
            }
        })
    })
}